export const generatePlaceholderImage = (text) => {
  const colors = [
    'bg-primary bg-opacity-25', 'bg-success bg-opacity-25', 'bg-warning bg-opacity-25', 
    'bg-danger bg-opacity-25', 'bg-info bg-opacity-25', 'bg-secondary bg-opacity-25'
  ];
  const randomColor = colors[Math.floor(Math.random() * colors.length)];
  
  return (
    <div className={`w-100 h-100 d-flex align-items-center justify-content-center ${randomColor} rounded-top`}>
      <span className="text-dark fw-bold">{text}</span>
    </div>
  );
};